import { NgModule }                 from '@angular/core';

import { HomeComponent }            from './home.component';
import { HomeRoutingModule }        from './home-routing.module';

import { SharedModule }             from '../../shared/shared.module';
import { ProductCarouselComponent } from './components/product-carousel/product-carousel.component';
import { ProductCardComponent }     from './components/product-card/product-card.component';
import { ProductPopupComponent }    from './components/product-popup/product-popup.component';

@NgModule({
    imports: [
        SharedModule,
        HomeRoutingModule
    ],
    declarations: [
        HomeComponent,
        ProductCarouselComponent,
        ProductCardComponent,
        ProductPopupComponent
    ],
})

export class HomeModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/home/home.module.ts